import React from "react";
import { useTranslation } from "react-i18next";
import { Dropdown, Button, Space, Grid } from "antd";
import { GlobalOutlined, DownOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";

const { useBreakpoint } = Grid;

const languages = [
  { key: "vi", label: "Tiếng Việt", flag: "🇻🇳" },
  { key: "en", label: "English", flag: "🇺🇸" },
];

export const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const screens = useBreakpoint();
  const currentLocale = i18n.language;
  const isMobile = !screens.md;

  const currentLanguage =
    languages.find((lang) => lang.key === currentLocale) || languages[0];

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("preferred_language", lang);
  };

  const items: MenuProps["items"] = languages.map((lang) => ({
    key: lang.key,
    label: (
      <Space>
        <span>{lang.flag}</span>
        <span>{lang.label}</span>
      </Space>
    ),
    disabled: lang.key === currentLocale,
    onClick: () => handleLanguageChange(lang.key),
  }));

  return (
    <Dropdown
      menu={{ items, selectedKeys: [currentLocale] }}
      trigger={["click"]}
    >
      <Button
        type="text"
        style={isMobile ? { width: 36, height: 36, padding: 0 } : undefined}
      >
        <Space size={isMobile ? 0 : "small"}>
          {isMobile ? (
            <span>{currentLanguage.flag}</span>
          ) : (
            <>
              <GlobalOutlined />
              <span>{currentLanguage.flag}</span>
              <span>{currentLanguage.label}</span>
              <DownOutlined />
            </>
          )}
        </Space>
      </Button>
    </Dropdown>
  );
};
